(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["littlefits-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('littlefits-banner-slider')) {
    class LittlefitsBannerSlider extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.stage = this.querySelector('.lfbs-stage');
        this.rotation = this.querySelector('[data-rotation]');
        this.status = this.querySelector('[data-status]');

        if (!this.slides.length) return;

        this.index = 0;
        this.requested = 0;
        this.sequence = 0;
        this.interval = Number(this.dataset.interval) || 5000;
        this.duration = Number(this.dataset.transition) || 700;
        this.autoplay = this.dataset.autoplay === 'true';
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches;
        this.hovered = false;
        this.visible = false;
        this.manualUntil = 0;
        this.editorSelections = new Set();
        this.suppressClickUntil = 0;
        this.pointer = null;

        this.slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === 0);
          slide.classList.remove('is-leaving');
          slide.inert = index !== 0;
          slide.setAttribute('aria-hidden', String(index !== 0));
        });

        this.classList.add('is-ready');
        this.updateRotation();

        this.listen(this, 'click', (event) => {
          const rotation = event.target.closest('[data-rotation]');
          const dot = event.target.closest('[data-dot]');
          const step = event.target.closest('[data-step]');

          if (rotation) {
            this.userPaused = !this.userPaused;
            this.updateRotation();
            this.schedule();
          } else if (dot) {
            this.go(Number(dot.dataset.dot), true);
          } else if (step) {
            this.go(this.requested + Number(step.dataset.step), true);
          }
        });

        this.listen(this, 'click', (event) => {
          if (
            performance.now() < this.suppressClickUntil &&
            event.target.closest('.lfbs-artwork')
          ) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true });

        this.listen(this, 'keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;

          let destination;

          if (event.key === 'ArrowRight') destination = this.requested + 1;
          if (event.key === 'ArrowLeft') destination = this.requested - 1;
          if (event.key === 'Home') destination = 0;
          if (event.key === 'End') destination = this.slides.length - 1;

          if (destination !== undefined && this.slides.length > 1) {
            event.preventDefault();
            this.go(destination, true);
          }
        });

        this.listen(this, 'focusin', () => this.schedule());

        this.listen(this, 'focusout', () => {
          queueMicrotask(() => {
            if (this.isConnected) this.schedule();
          });
        });

        this.listen(this, 'pointerenter', (event) => {
          if (event.pointerType === 'mouse') {
            this.hovered = true;
            this.schedule();
          }
        });

        this.listen(this, 'pointerleave', (event) => {
          if (event.pointerType === 'mouse') {
            this.hovered = false;
            this.schedule();
          }
        });

        this.listen(this.stage, 'dragstart', (event) => {
          event.preventDefault();
        });

        this.listen(this.stage, 'pointerdown', (event) => {
          if (
            !event.isPrimary ||
            event.pointerType === 'mouse' ||
            event.target.closest('button')
          ) return;

          this.pointer = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY
          };

          this.manualUntil = Date.now() + 8000;
          this.schedule();
        }, { passive: true });

        this.listen(window, 'pointerup', (event) => {
          if (!this.pointer || event.pointerId !== this.pointer.id) return;

          const dx = event.clientX - this.pointer.x;
          const dy = event.clientY - this.pointer.y;
          this.pointer = null;
          this.manualUntil = Date.now() + 8000;

          if (
            this.slides.length > 1 &&
            Math.abs(dx) > 45 &&
            Math.abs(dx) > Math.abs(dy) * 1.2
          ) {
            this.suppressClickUntil = performance.now() + 700;
            this.go(this.requested + (dx < 0 ? 1 : -1), true);
          } else {
            this.schedule();
          }
        }, { passive: true });

        this.listen(window, 'pointercancel', (event) => {
          if (!this.pointer || event.pointerId !== this.pointer.id) return;
          this.pointer = null;
          this.schedule();
        }, { passive: true });

        this.listen(document, 'visibilitychange', () => this.schedule());

        this.listen(this.motion, 'change', () => {
          if (this.motion.matches) this.userPaused = true;
          this.updateRotation();
          this.schedule();
        });

        this.listen(document, 'shopify:section:select', (event) => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          this.editorSelections.add('section');
          this.schedule();
        });

        this.listen(document, 'shopify:section:deselect', (event) => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          this.editorSelections.delete('section');
          this.schedule();
        });

        this.listen(document, 'shopify:block:select', (event) => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;

          this.editorSelections.add('block');
          const index = this.slides.findIndex(
            (slide) => slide.dataset.blockId === event.detail.blockId
          );

          if (index !== -1) this.go(index, false);
          this.schedule();
        });

        this.listen(document, 'shopify:block:deselect', (event) => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          this.editorSelections.delete('block');
          this.schedule();
        });

        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0 });

        this.observer.observe(this);
        this.schedule();
      }

      listen(target, name, callback, options = {}) {
        target.addEventListener(name, callback, {
          ...options,
          signal: this.controller.signal
        });
      }

      clearTimers() {
        clearTimeout(this.timer);
        clearTimeout(this.warmupTimer);
      }

      canRotate() {
        return (
          this.autoplay &&
          this.slides.length > 1 &&
          !this.userPaused &&
          !this.hovered &&
          !this.pointer &&
          this.visible &&
          !document.hidden &&
          !this.contains(document.activeElement) &&
          this.editorSelections.size === 0
        );
      }

      schedule() {
        this.clearTimers();

        const rotating = this.canRotate();
        this.classList.toggle('is-paused', !rotating);

        if (!rotating) return;

        const wait = Math.max(
          this.interval,
          this.manualUntil - Date.now()
        );

        // Load only the upcoming image shortly before it is needed.
        this.warmupTimer = setTimeout(() => {
          this.hydrate((this.index + 1) % this.slides.length);
        }, Math.max(0, wait - 1500));

        this.timer = setTimeout(() => {
          this.go(this.index + 1, false);
        }, wait);
      }

      hydrate(index) {
        const slide = this.slides[index];
        const template = slide.querySelector('template[data-picture]');

        if (template) {
          template.replaceWith(template.content.cloneNode(true));
        }

        const image = slide.querySelector('img');

        // Deferred slides have no active image element until requested.
        if (image) image.loading = 'eager';

        return image;
      }

      async go(destination, manual = false) {
        if (this.slides.length < 2) return;

        this.clearTimers();

        if (manual) this.manualUntil = Date.now() + 8000;

        const target =
          (destination % this.slides.length + this.slides.length) %
          this.slides.length;

        const sequence = ++this.sequence;
        this.requested = target;

        if (target === this.index) {
          this.schedule();
          return;
        }

        const image = this.hydrate(target);

        if (image) {
          image.fetchPriority = 'auto';

          try {
            await image.decode();
          } catch (error) {
            // Keep the existing banner visible if the next image fails.
          }
        }

        if (!this.isConnected || sequence !== this.sequence) return;

        if (!image || !image.naturalWidth) {
          this.requested = this.index;

          if (manual) {
            this.status.textContent = 'This banner could not be loaded.';
          }

          this.schedule();
          return;
        }

        clearTimeout(this.cleanupTimer);

        this.slides.forEach((slide) => {
          slide.classList.remove('is-leaving');
        });

        const previous = this.slides[this.index];
        const incoming = this.slides[target];
        const moveFocus = previous.contains(document.activeElement);

        this.style.setProperty(
          '--lfbs-shift',
          destination < this.index ? '-18px' : '18px'
        );

        // Commit the incoming slide's initial position before animating.
        incoming.getBoundingClientRect();

        previous.classList.remove('is-active');
        previous.classList.add('is-leaving');
        previous.inert = true;
        previous.setAttribute('aria-hidden', 'true');

        incoming.inert = false;
        incoming.setAttribute('aria-hidden', 'false');
        incoming.classList.add('is-active');

        this.index = target;
        this.requested = target;

        this.dots.forEach((dot, index) => {
          if (index === target) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        if (moveFocus) this.focus({ preventScroll: true });

        if (manual) {
          this.status.textContent =
            `Banner ${target + 1} of ${this.slides.length}`;
        }

        this.cleanupTimer = setTimeout(() => {
          previous.classList.remove('is-leaving');
        }, this.motion.matches ? 200 : this.duration + 50);

        this.schedule();
      }

      updateRotation() {
        if (!this.rotation) return;

        const label = this.userPaused
          ? 'Start automatic slide rotation'
          : 'Pause automatic slide rotation';

        this.rotation.setAttribute('aria-label', label);
        this.rotation.setAttribute('title', label);
        this.rotation.querySelector('[data-pause-icon]').hidden =
          this.userPaused;
        this.rotation.querySelector('[data-play-icon]').hidden =
          !this.userPaused;
      }

      disconnectedCallback() {
        this.sequence++;
        this.clearTimers();
        clearTimeout(this.cleanupTimer);
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.classList.remove('is-ready');
      }
    }

    customElements.define(
      'littlefits-banner-slider',
      LittlefitsBannerSlider
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["littlefits-premium-picks"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('littlefits-premium-picks')) {

  class LittlefitsPremiumPicks extends HTMLElement {

    connectedCallback() {

      if (this.controller) return;

      this.track =
        this.querySelector(
          '[data-product-track]'
        );

      if (!this.track) return;


      this.controller =
        new AbortController();


      this.cards =
        [
          ...this.querySelectorAll(
            '[data-product-card]'
          )
        ];


      this.controls =
        this.querySelector(
          '[data-section-controls]'
        );


      this.sectionDots =
        this.querySelector(
          '[data-section-dots]'
        );


      this.previous =
        this.querySelector(
          '[data-product-step="-1"]'
        );


      this.next =
        this.querySelector(
          '[data-product-step="1"]'
        );


      this.status =
        this.querySelector(
          '[data-status]'
        );


      this.mobile =
        matchMedia(
          '(max-width: 749px)'
        );


      this.motion =
        matchMedia(
          '(prefers-reduced-motion: reduce)'
        );


      this.points = [0];

      this.productIndex = 0;

      this.suppressClickUntil = 0;

      this.wishlistKey =
        'littlefits:wishlist:v1';


      this.galleries =
        [
          ...this.querySelectorAll(
            '[data-gallery]'
          )
        ].map((element) => {

          const gallery = {

            element,

            track:
              element.querySelector(
                '[data-gallery-track]'
              ),

            frames:
              [
                ...element.querySelectorAll(
                  '[data-image-frame]'
                )
              ],

            dots:
              [
                ...element.querySelectorAll(
                  '[data-image-dot]'
                )
              ],

            previous:
              element.querySelector(
                '[data-image-step="-1"]'
              ),

            next:
              element.querySelector(
                '[data-image-step="1"]'
              ),

            index: 0,

            used: false,

            request: 0

          };


          element.galleryState =
            gallery;


          element
            .querySelectorAll(
              '[data-image-step], [data-image-dots]'
            )
            .forEach((control) => {

              control.hidden = false;

            });


          this.listen(
            gallery.track,
            'scroll',
            () => {

              if (gallery.frame) return;


              gallery.frame =
                requestAnimationFrame(() => {

                  gallery.frame = null;


                  const position =
                    Math.abs(
                      gallery.track.scrollLeft
                    );


                  gallery.index =
                    Math.max(
                      0,
                      Math.min(
                        gallery.frames.length - 1,
                        Math.round(
                          position /
                          Math.max(
                            1,
                            gallery.track.clientWidth
                          )
                        )
                      )
                    );


                  this.updateGallery(
                    gallery
                  );


                  if (gallery.used) {

                    this.primeGallery(
                      gallery
                    );

                  }

                });

            },
            {
              passive: true
            }
          );


          this.listen(
            element,
            'pointerenter',
            (event) => {

              if (
                event.pointerType === 'mouse' &&
                gallery.frames.length > 1
              ) {

                this.primeGallery(
                  gallery
                );

              }

            }
          );


          this.updateGallery(
            gallery
          );


          return gallery;

        });


      this.classList.add(
        'is-ready'
      );


      this.listen(
        this,
        'click',
        (event) => {

          if (
            performance.now() <
              this.suppressClickUntil &&
            event.target.closest('a')
          ) {

            event.preventDefault();

            event.stopImmediatePropagation();

          }

        },
        {
          capture: true
        }
      );


      this.listen(
        this,
        'click',
        (event) => {

          const imageStep =
            event.target.closest(
              '[data-image-step]'
            );


          const imageDot =
            event.target.closest(
              '[data-image-dot]'
            );


          const productStep =
            event.target.closest(
              '[data-product-step]'
            );


          const productDot =
            event.target.closest(
              '[data-product-dot]'
            );


          const wishlist =
            event.target.closest(
              '[data-wishlist]'
            );


          const gallery =
            event.target
              .closest(
                '[data-gallery]'
              )
              ?.galleryState;


          if (
            imageStep &&
            gallery
          ) {

            this.goGallery(
              gallery,
              gallery.index +
                Number(
                  imageStep.dataset.imageStep
                )
            );

          } else if (
            imageDot &&
            gallery
          ) {

            this.goGallery(
              gallery,
              Number(
                imageDot.dataset.imageDot
              )
            );

          } else if (
            productStep
          ) {

            this.goProduct(
              this.productIndex +
                Number(
                  productStep.dataset.productStep
                )
            );

          } else if (
            productDot
          ) {

            this.goProduct(
              Number(
                productDot.dataset.productDot
              )
            );

          } else if (
            wishlist
          ) {

            this.toggleWishlist(
              wishlist
            );

          }

        }
      );


      this.listen(
        this,
        'keydown',
        (event) => {

          this.suppressClickUntil = 0;


          if (
            event.altKey ||
            event.ctrlKey ||
            event.metaKey
          ) {
            return;
          }


          const gallery =
            event.target
              .closest(
                '[data-gallery]'
              )
              ?.galleryState;


          let target;


          if (
            gallery &&
            gallery.frames.length > 1
          ) {

            const rtl =
              getComputedStyle(
                gallery.track
              ).direction === 'rtl';


            if (
              event.key ===
              'ArrowRight'
            ) {

              target =
                gallery.index +
                (rtl ? -1 : 1);

            }


            if (
              event.key ===
              'ArrowLeft'
            ) {

              target =
                gallery.index +
                (rtl ? 1 : -1);

            }


            if (
              event.key === 'Home'
            ) {

              target = 0;

            }


            if (
              event.key === 'End'
            ) {

              target =
                gallery.frames.length - 1;

            }


            if (
              target !== undefined
            ) {

              event.preventDefault();

              event.stopPropagation();

              this.goGallery(
                gallery,
                target
              );

            }


          } else if (
            event.target === this.track &&
            this.mobile.matches
          ) {

            if (
              event.key ===
              'ArrowRight'
            ) {

              target =
                this.productIndex +
                (this.rtl ? -1 : 1);

            }


            if (
              event.key ===
              'ArrowLeft'
            ) {

              target =
                this.productIndex +
                (this.rtl ? 1 : -1);

            }


            if (
              event.key === 'Home'
            ) {

              target = 0;

            }


            if (
              event.key === 'End'
            ) {

              target =
                this.points.length - 1;

            }


            if (
              target !== undefined
            ) {

              event.preventDefault();

              this.goProduct(
                target
              );

            }

          }

        }
      );


      this.listen(
        this,
        'pointerdown',
        (event) => {

          if (!event.isPrimary) {
            return;
          }


          this.suppressClickUntil = 0;


          this.pointer = {

            id:
              event.pointerId,

            x:
              event.clientX,

            y:
              event.clientY

          };


          const gallery =
            event.target
              .closest(
                '[data-gallery]'
              )
              ?.galleryState;


          if (gallery) {

            gallery.used = true;

            this.primeGallery(
              gallery
            );

          }

        },
        {
          passive: true
        }
      );


      this.listen(
        window,
        'pointerup',
        (event) => {

          if (
            !this.pointer ||
            event.pointerId !==
              this.pointer.id
          ) {
            return;
          }


          const distance =
            Math.hypot(

              event.clientX -
                this.pointer.x,

              event.clientY -
                this.pointer.y

            );


          if (distance > 10) {

            this.suppressClickUntil =
              performance.now() +
              700;

          }


          this.pointer = null;

        },
        {
          passive: true
        }
      );


      this.listen(
        window,
        'pointercancel',
        (event) => {

          if (
            !this.pointer ||
            event.pointerId !==
              this.pointer.id
          ) {
            return;
          }


          this.suppressClickUntil =
            performance.now() +
            700;


          this.pointer = null;

        },
        {
          passive: true
        }
      );


      this.listen(
        this,
        'dragstart',
        (event) => {

          if (
            event.target.closest(
              '.lfpp-gallery'
            )
          ) {

            event.preventDefault();

          }

        }
      );


      this.listen(
        this.track,
        'scroll',
        () => {

          if (
            this.productFrame
          ) {
            return;
          }


          this.productFrame =
            requestAnimationFrame(() => {

              this.productFrame = null;

              this.updateProducts();

            });

        },
        {
          passive: true
        }
      );


      this.resizeObserver =
        new ResizeObserver(
          () => this.measure()
        );


      this.resizeObserver.observe(
        this.track
      );


      this.listen(
        this.mobile,
        'change',
        () => this.measure()
      );


      this.measure();


      this.querySelectorAll(
        '[data-wishlist]'
      ).forEach((button) => {

        button.hidden = false;

      });


      this.syncWishlist();


      this.listen(
        window,
        'littlefits:wishlistchange',
        () => this.syncWishlist()
      );


      this.listen(
        window,
        'storage',
        (event) => {

          if (
            event.key ===
              this.wishlistKey ||
            event.key === null
          ) {

            this.syncWishlist();

          }

        }
      );


      this.setupReveal();


      this.listen(
        this.motion,
        'change',
        () => {

          if (
            this.motion.matches
          ) {

            this.revealEverything();

          }

        }
      );


      this.listen(
        this,
        'focusin',
        (event) => {

          const element =
            event.target.closest(
              '[data-reveal]'
            );


          if (element) {

            this.reveal(
              element
            );

          }

        }
      );


      this.listen(
        this,
        'shopify:block:select',
        (event) => {

          const card =
            event.target.closest(
              '[data-product-card]'
            );


          if (!card) return;


          this.reveal(
            card
          );


          if (
            this.mobile.matches
          ) {

            this.goProduct(
              this.cards.indexOf(
                card
              )
            );

          } else {

            card.scrollIntoView({

              block: 'nearest',

              behavior: 'auto'

            });

          }

        }
      );

    }


    listen(
      target,
      event,
      callback,
      options = {}
    ) {

      target.addEventListener(
        event,
        callback,
        {

          ...options,

          signal:
            this.controller.signal

        }
      );

    }


    hydrate(
      gallery,
      index
    ) {

      const frame =
        gallery.frames[index];


      if (!frame) return null;


      const template =
        frame.querySelector(
          '[data-deferred-image]'
        );


      if (template) {

        const fragment =
          template.content.cloneNode(
            true
          );


        const image =
          fragment.querySelector(
            'img'
          );


        if (image) {

          image.loading =
            'eager';

        }


        template.replaceWith(
          fragment
        );

      }


      return frame.querySelector(
        'img'
      );

    }


    primeGallery(
      gallery
    ) {

      this.hydrate(
        gallery,
        gallery.index
      );


      this.hydrate(
        gallery,
        gallery.index + 1
      );


      this.hydrate(
        gallery,
        gallery.index - 1
      );

    }


    async goGallery(
      gallery,
      destination
    ) {

      const target =
        Math.max(
          0,
          Math.min(
            destination,
            gallery.frames.length - 1
          )
        );


      const request =
        ++gallery.request;


      gallery.used = true;


      const image =
        this.hydrate(
          gallery,
          target
        );


      if (image) {

        try {

          await image.decode();

        } catch {

          if (
            !image.naturalWidth
          ) {

            if (
              this.isConnected &&
              request ===
                gallery.request
            ) {

              this.status.textContent =
                'This product image could not load.';

            }

            return;

          }

        }

      }


      if (
        !this.isConnected ||
        request !==
          gallery.request
      ) {
        return;
      }


      const rtl =
        getComputedStyle(
          gallery.track
        ).direction === 'rtl';


      gallery.track.scrollTo({

        left:
          target *
          gallery.track.clientWidth *
          (rtl ? -1 : 1),

        behavior:
          this.motion.matches
            ? 'auto'
            : 'smooth'

      });


      this.status.textContent =
        `Image ${target + 1} of ${gallery.frames.length} for ${
          gallery.element.dataset.productTitle
        }.`;

    }


    updateGallery(
      gallery
    ) {

      gallery.frames.forEach(
        (frame, index) => {

          const active =
            index ===
            gallery.index;


          frame.inert =
            !active;


          frame.setAttribute(
            'aria-hidden',
            String(!active)
          );

        }
      );


      gallery.dots.forEach(
        (dot, index) => {

          if (
            index ===
            gallery.index
          ) {

            dot.setAttribute(
              'aria-current',
              'true'
            );

          } else {

            dot.removeAttribute(
              'aria-current'
            );

          }

        }
      );


      if (
        gallery.previous
      ) {

        gallery.previous.disabled =
          gallery.index === 0;

      }


      if (
        gallery.next
      ) {

        gallery.next.disabled =
          gallery.index ===
          gallery.frames.length - 1;

      }

    }


    measure() {

      this.rtl =
        getComputedStyle(
          this.track
        ).direction === 'rtl';


      this.galleries.forEach(
        (gallery) => {

          const rtl =
            getComputedStyle(
              gallery.track
            ).direction === 'rtl';


          gallery.track.scrollTo({

            left:
              gallery.index *
              gallery.track.clientWidth *
              (rtl ? -1 : 1),

            behavior:
              'auto'

          });

        }
      );


      /*
       * Desktop stays a normal grid.
       * Only mobile becomes a carousel.
       */

      if (
        !this.mobile.matches
      ) {

        this.track.removeAttribute(
          'tabindex'
        );


        this.controls.hidden =
          true;


        return;

      }


      this.track.tabIndex = 0;


      const maximum =
        Math.max(
          0,
          this.track.scrollWidth -
            this.track.clientWidth
        );


      const first =
        this.cards[0]
          .getBoundingClientRect();


      const points = [];


      this.cards.forEach(
        (card) => {

          const rect =
            card.getBoundingClientRect();


          const distance =
            this.rtl

              ? first.right -
                rect.right

              : rect.left -
                first.left;


          const point =
            Math.max(
              0,
              Math.min(
                distance,
                maximum
              )
            );


          if (
            !points.length ||
            Math.abs(
              point -
              points.at(-1)
            ) > 2
          ) {

            points.push(
              point
            );

          }

        }
      );


      this.points =
        points.length
          ? points
          : [0];


      const signature =
        this.points
          .map(Math.round)
          .join(',');


      if (
        this.sectionDots &&
        signature !==
          this.pointSignature
      ) {

        const hadFocus =
          this.sectionDots.contains(
            document.activeElement
          );


        this.sectionDots.replaceChildren();


        this.points.forEach(
          (point, index) => {

            const button =
              document.createElement(
                'button'
              );


            button.type =
              'button';


            button.className =
              'lfpp-section-dot';


            button.dataset.productDot =
              String(index);


            button.setAttribute(
              'aria-label',
              `Show product position ${index + 1}`
            );


            button.setAttribute(
              'aria-controls',
              this.track.id
            );


            this.sectionDots.append(
              button
            );

          }
        );


        if (hadFocus) {

          this.sectionDots.children[
            Math.min(
              this.productIndex,
              this.points.length - 1
            )
          ]?.focus({

            preventScroll: true

          });

        }

      }


      this.pointSignature =
        signature;


      this.controls.hidden =
        maximum < 3 ||
        (
          !this.previous &&
          !this.sectionDots
        );


      this.updateProducts();

    }


    updateProducts() {

      if (
        !this.mobile.matches
      ) {
        return;
      }


      const position =
        Math.abs(
          this.track.scrollLeft
        );


      this.productIndex =
        this.points.reduce(
          (
            closest,
            point,
            index
          ) => {

            return (
              Math.abs(
                point -
                position
              ) <
              Math.abs(
                this.points[closest] -
                position
              )
            )

              ? index
              : closest;

          },
          0
        );


      this.sectionDots
        ?.querySelectorAll(
          'button'
        )
        .forEach(
          (button, index) => {

            if (
              index ===
              this.productIndex
            ) {

              button.setAttribute(
                'aria-current',
                'true'
              );

            } else {

              button.removeAttribute(
                'aria-current'
              );

            }

          }
        );


      if (
        this.previous
      ) {

        this.previous.disabled =
          this.productIndex === 0;

      }


      if (
        this.next
      ) {

        this.next.disabled =
          this.productIndex ===
          this.points.length - 1;

      }

    }


    goProduct(
      destination
    ) {

      const target =
        Math.max(
          0,
          Math.min(
            destination,
            this.points.length - 1
          )
        );


      this.track.scrollTo({

        left:
          this.points[target] *
          (this.rtl ? -1 : 1),

        behavior:
          this.motion.matches
            ? 'auto'
            : 'smooth'

      });

    }


    readWishlist() {

      try {

        const stored =
          JSON.parse(

            localStorage.getItem(
              this.wishlistKey
            ) || '[]'

          );


        return new Set(

          Array.isArray(
            stored
          )

            ? stored.filter(
                (value) =>
                  typeof value ===
                  'string'
              )

            : []

        );


      } catch {

        return new Set();

      }

    }


    syncWishlist() {

      const saved =
        this.readWishlist();


      this
        .querySelectorAll(
          '[data-wishlist]'
        )
        .forEach(
          (button) => {

            const active =
              saved.has(
                button.dataset.productId
              );


            button.setAttribute(
              'aria-pressed',
              String(active)
            );


            button.setAttribute(

              'aria-label',

              `${active ? 'Remove' : 'Save'} ${button.dataset.productTitle} ${
                active
                  ? 'from'
                  : 'to'
              } wishlist`

            );

          }
        );

    }


    toggleWishlist(
      button
    ) {

      const saved =
        this.readWishlist();


      const id =
        button.dataset.productId;


      const removing =
        saved.has(id);


      if (removing) {

        saved.delete(id);

      } else {

        saved.add(id);

      }


      try {

        localStorage.setItem(

          this.wishlistKey,

          JSON.stringify(
            [...saved]
          )

        );


        window.dispatchEvent(

          new CustomEvent(
            'littlefits:wishlistchange'
          )

        );


        this.status.textContent =
          `${button.dataset.productTitle} ${
            removing
              ? 'removed from'
              : 'saved to'
          } your wishlist on this browser.`;


      } catch {

        this.status.textContent =
          'Your browser could not save this wishlist selection.';

      }

    }


    setupReveal() {

      if (

        this.dataset.revealEnabled !==
          'true' ||

        this.motion.matches ||

        window.Shopify?.designMode ||

        !(
          'IntersectionObserver'
          in window
        )

      ) {

        return;

      }


      this.revealObserver =
        new IntersectionObserver(

          (entries) => {

            entries.forEach(
              (entry) => {

                if (
                  entry.isIntersecting
                ) {

                  this.reveal(
                    entry.target
                  );

                }

              }
            );

          },

          {
            threshold: 0.08
          }

        );


      this
        .querySelectorAll(
          '[data-reveal]'
        )
        .forEach(
          (element) => {

            element.classList.add(
              'lfpp-reveal-pending'
            );


            element.getBoundingClientRect();


            element.classList.add(
              'lfpp-reveal-ready'
            );


            this.revealObserver.observe(
              element
            );

          }
        );

    }


    reveal(
      element
    ) {

      element.classList.remove(
        'lfpp-reveal-pending'
      );


      this.revealObserver
        ?.unobserve(
          element
        );

    }


    revealEverything() {

      this.revealObserver
        ?.disconnect();


      this
        .querySelectorAll(
          '[data-reveal]'
        )
        .forEach(
          (element) => {

            element.classList.remove(
              'lfpp-reveal-pending'
            );

          }
        );

    }


    disconnectedCallback() {

      this.controller
        ?.abort();


      this.resizeObserver
        ?.disconnect();


      this.revealObserver
        ?.disconnect();


      cancelAnimationFrame(
        this.productFrame
      );


      this.galleries
        ?.forEach(
          (gallery) => {

            gallery.request++;


            cancelAnimationFrame(
              gallery.frame
            );

          }
        );


      this.revealEverything();


      this.classList.remove(
        'is-ready'
      );


      this.controller =
        null;

    }

  }


  customElements.define(
    'littlefits-premium-picks',
    LittlefitsPremiumPicks
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["littlefits-promo-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('littlefits-promo-banner')) {
    class LittlefitsPromoBanner extends HTMLElement {
      connectedCallback() {
        if (
          this.revealed ||
          this.controller ||
          this.dataset.reveal !== 'true' ||
          window.Shopify?.designMode ||
          !('IntersectionObserver' in window)
        ) return;

        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motion.matches) return;

        this.target = this.querySelector('[data-reveal-target]');
        if (!this.target) return;

        this.controller = new AbortController();

        this.target.classList.remove('lfpb-reveal-ready');
        this.target.classList.add('lfpb-reveal-pending');

        // Establish the initial position before enabling the transition.
        this.target.getBoundingClientRect();
        this.target.classList.add('lfpb-reveal-ready');

        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.reveal();
          }
        }, { threshold: 0.1 });

        this.observer.observe(this.target);

        this.addEventListener('focusin', () => this.reveal(), {
          signal: this.controller.signal
        });

        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.reveal();
        }, {
          signal: this.controller.signal
        });
      }

      reveal() {
        this.revealed = true;
        this.target?.classList.remove('lfpb-reveal-pending');
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.target?.classList.remove('lfpb-reveal-pending');
        this.controller = null;
      }
    }

    customElements.define(
      'littlefits-promo-banner',
      LittlefitsPromoBanner
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["littlefits-seo-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'littlefits-seo-content';

    if (customElements.get(elementName)) return;

    class LittlefitsSEOContent extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();

        // Open the content when a block is selected for editing.
        this.addEventListener('shopify:block:select', () => {
          const details = this.querySelector('.lfseo-details');

          if (details) {
            details.open = true;
          }
        }, {
          signal: this.controller.signal
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    }

    customElements.define(elementName, LittlefitsSEOContent);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["littlefits-tabbed-product-carousel"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('littlefits-product-tabs')) {

    class LittlefitsProductTabs extends HTMLElement {


      connectedCallback() {

        if (this.controller) return;


        this.controller =
          new AbortController();


        this.tabs =
          [
            ...this.querySelectorAll(
              '[data-tab]'
            )
          ];


        this.panels =
          [
            ...this.querySelectorAll(
              '[data-panel]'
            )
          ];


        this.tablist =
          this.querySelector(
            '[data-tablist]'
          );


        this.footer =
          this.querySelector(
            '[data-footer]'
          );


        this.viewAll =
          this.querySelector(
            '[data-view-all-button]'
          );


        this.status =
          this.querySelector(
            '[data-status]'
          );


        this.motion =
          matchMedia(
            '(prefers-reduced-motion: reduce)'
          );


        this.mobile =
          matchMedia(
            '(max-width: 749px)'
          );


        this.rails =
          new Set();


        this.activeIndex = 0;


        this.suppressClickUntil = 0;


        this.wishlistKey =
          'littlefits:wishlist:v1';


        this.autoplayTimer =
          null;


        this.autoplayDelay =
          Math.max(
            2,
            Number(
              this.dataset.autoplaySpeed
            ) || 5
          ) * 1000;


        this.classList.add(
          'is-ready'
        );


        this.activate(
          0,
          false
        );


        this.syncLayout();


        /*
         * Prevent accidental link click
         * after swiping.
         */
        this.listen(
          this,
          'click',
          (event) => {

            if (
              performance.now() <
                this.suppressClickUntil &&
              event.target.closest('a')
            ) {

              event.preventDefault();

              event.stopImmediatePropagation();

            }

          },
          {
            capture: true
          }
        );


        /*
         * CLICK CONTROLS
         */
        this.listen(
          this,
          'click',
          (event) => {

            const tab =
              event.target.closest(
                '[data-tab]'
              );


            if (tab) {

              this.activate(
                this.tabs.indexOf(
                  tab
                )
              );


              this.restartAutoplay();


              return;

            }


            const gallery =
              event.target.closest(
                '[data-gallery]'
              );


            const panel =
              event.target.closest(
                '[data-panel]'
              );


            const imageStep =
              event.target.closest(
                '[data-image-step]'
              );


            const imageDot =
              event.target.closest(
                '[data-image-dot]'
              );


            const mainStep =
              event.target.closest(
                '[data-main-step]'
              );


            const heart =
              event.target.closest(
                '[data-wishlist]'
              );


            if (
              imageStep &&
              gallery?.railState
            ) {

              const rail =
                gallery.railState;


              this.go(
                rail,
                rail.index +
                  Number(
                    imageStep.dataset.imageStep
                  )
              );


            } else if (
              imageDot &&
              gallery?.railState
            ) {

              this.go(
                gallery.railState,
                Number(
                  imageDot.dataset.imageDot
                )
              );


            } else if (
              mainStep &&
              panel?.mainRail &&
              !this.mobile.matches
            ) {

              const rail =
                panel.mainRail;


              this.go(
                rail,
                rail.index +
                  Number(
                    mainStep.dataset.mainStep
                  )
              );


              this.restartAutoplay();


            } else if (
              heart
            ) {

              this.toggleWishlist(
                heart
              );

            }

          }
        );


        /*
         * KEYBOARD
         */
        this.listen(
          this,
          'keydown',
          (event) => {

            this.suppressClickUntil = 0;


            if (
              event.altKey ||
              event.ctrlKey ||
              event.metaKey
            ) {
              return;
            }


            const tab =
              event.target.closest(
                '[data-tab]'
              );


            if (
              tab &&
              !this.mobile.matches
            ) {

              const index =
                this.tabs.indexOf(
                  tab
                );


              const rtl =
                getComputedStyle(
                  this.tablist
                ).direction === 'rtl';


              let target;


              if (
                event.key ===
                'ArrowRight'
              ) {

                target =
                  index +
                  (rtl ? -1 : 1);

              }


              if (
                event.key ===
                'ArrowLeft'
              ) {

                target =
                  index +
                  (rtl ? 1 : -1);

              }


              if (
                event.key ===
                'Home'
              ) {

                target = 0;

              }


              if (
                event.key ===
                'End'
              ) {

                target =
                  this.tabs.length - 1;

              }


              if (
                target !== undefined
              ) {

                event.preventDefault();


                target =
                  (
                    target +
                    this.tabs.length
                  ) %
                  this.tabs.length;


                this.tabs.forEach(
                  (
                    item,
                    position
                  ) => {

                    item.tabIndex =
                      position === target
                        ? 0
                        : -1;

                  }
                );


                this.tabs[target].focus({

                  preventScroll: true

                });


                this.tabs[target]
                  .scrollIntoView({

                    block:
                      'nearest',

                    inline:
                      'nearest',

                    behavior:
                      'auto'

                  });

              }


              return;

            }


            const gallery =
              event.target.closest(
                '[data-gallery]'
              );


            const panel =
              event.target.closest(
                '[data-panel]'
              );


            const rail =
              gallery?.railState ||
              (
                !this.mobile.matches &&
                event.target.matches(
                  '[data-main-track]'
                )
                  ? panel?.mainRail
                  : null
              );


            if (
              !rail ||
              rail.points.length < 2
            ) {
              return;
            }


            let target;


            if (
              event.key ===
                'ArrowRight'
            ) {

              target =
                rail.index +
                (rail.rtl ? -1 : 1);

            }


            if (
              event.key ===
                'ArrowLeft'
            ) {

              target =
                rail.index +
                (rail.rtl ? 1 : -1);

            }


            if (
              event.key ===
                'Home'
            ) {

              target = 0;

            }


            if (
              event.key ===
                'End'
            ) {

              target =
                rail.points.length - 1;

            }


            if (
              target !== undefined
            ) {

              event.preventDefault();

              event.stopPropagation();


              this.go(
                rail,
                target
              );


              if (
                !rail.image
              ) {

                this.restartAutoplay();

              }

            }

          }
        );


        /*
         * POINTER / SWIPE
         */
        this.listen(
          this,
          'pointerdown',
          (event) => {

            if (
              !event.isPrimary
            ) {
              return;
            }


            this.suppressClickUntil = 0;


            if (
              event.target.closest(
                '[data-main-track]'
              )
            ) {

              this.stopAutoplay();

            }


            this.pointer = {

              id:
                event.pointerId,

              x:
                event.clientX,

              y:
                event.clientY

            };


            const rail =
              event.target
                .closest(
                  '[data-gallery]'
                )
                ?.railState;


            if (rail) {

              rail.used = true;

              this.prime(
                rail
              );

            }

          },
          {
            passive: true
          }
        );


        this.listen(
          window,
          'pointerup',
          (event) => {

            if (
              !this.pointer ||
              event.pointerId !==
                this.pointer.id
            ) {
              return;
            }


            if (
              Math.hypot(

                event.clientX -
                  this.pointer.x,

                event.clientY -
                  this.pointer.y

              ) > 10
            ) {

              this.suppressClickUntil =
                performance.now() +
                700;

            }


            this.pointer =
              null;


            this.restartAutoplay();

          },
          {
            passive: true
          }
        );


        this.listen(
          window,
          'pointercancel',
          (event) => {

            if (
              !this.pointer ||
              event.pointerId !==
                this.pointer.id
            ) {
              return;
            }


            this.suppressClickUntil =
              performance.now() +
              700;


            this.pointer =
              null;


            this.restartAutoplay();

          },
          {
            passive: true
          }
        );


        this.listen(
          this,
          'dragstart',
          (event) => {

            if (
              event.target.closest(
                '[data-gallery]'
              )
            ) {

              event.preventDefault();

            }

          }
        );


        /*
         * RESPONSIVE MEASUREMENT
         */
        this.resizeObserver =
          new ResizeObserver(
            () => {

              this.rails.forEach(
                (rail) => {

                  if (
                    this.railIsVisible(
                      rail
                    )
                  ) {

                    this.measure(
                      rail
                    );

                  }

                }
              );

            }
          );


        const container =
          this.querySelector(
            '.lftc-container'
          );


        if (container) {

          this.resizeObserver.observe(
            container
          );

        }


        this.listen(
          this.mobile,
          'change',
          () => {

            this.syncLayout();

          }
        );


        /*
         * WISHLIST
         */
        this
          .querySelectorAll(
            '[data-wishlist]'
          )
          .forEach(
            (button) => {

              button.hidden =
                false;

            }
          );


        this.syncWishlist();


        this.listen(
          window,
          'littlefits:wishlistchange',
          () =>
            this.syncWishlist()
        );


        this.listen(
          window,
          'storage',
          (event) => {

            if (
              event.key ===
                this.wishlistKey ||
              event.key === null
            ) {

              this.syncWishlist();

            }

          }
        );


        /*
         * VISIBILITY
         */
        this.listen(
          document,
          'visibilitychange',
          () => {

            if (
              document.hidden
            ) {

              this.stopAutoplay();

            } else {

              this.scheduleAutoplay();

            }

          }
        );


        /*
         * REDUCED MOTION
         */
        this.setupReveal();


        this.listen(
          this.motion,
          'change',
          () => {

            if (
              this.motion.matches
            ) {

              this.stopAutoplay();

              this.reveal();

            } else {

              this.scheduleAutoplay();

            }

          }
        );


        /*
         * Focus pauses desktop autoplay.
         */
        this.listen(
          this,
          'focusin',
          () => {

            this.reveal();

            this.stopAutoplay();

          }
        );


        this.listen(
          this,
          'focusout',
          () => {

            requestAnimationFrame(
              () => {

                if (
                  !this.contains(
                    document.activeElement
                  )
                ) {

                  this.scheduleAutoplay();

                }

              }
            );

          }
        );


        /*
         * THEME EDITOR
         */
        this.listen(
          this,
          'shopify:block:select',
          (event) => {

            const index =
              this.tabs.findIndex(
                (tab) =>
                  tab.dataset.blockId ===
                  event.detail.blockId
              );


            if (
              index === -1
            ) {
              return;
            }


            this.activate(
              index,
              false
            );


            if (
              this.mobile.matches
            ) {

              this.panels[index]
                ?.scrollIntoView({

                  block:
                    'start',

                  behavior:
                    'smooth'

                });

            }

          }
        );


        this.scheduleAutoplay();

      }


      listen(
        target,
        name,
        callback,
        options = {}
      ) {

        target.addEventListener(
          name,
          callback,
          {

            ...options,

            signal:
              this.controller.signal

          }
        );

      }


      railIsVisible(
        rail
      ) {

        if (
          !rail?.track
        ) {
          return false;
        }


        if (
          rail.image
        ) {

          return (
            rail.track
              .getClientRects()
              .length > 0
          );

        }


        if (
          this.mobile.matches
        ) {

          return true;

        }


        return (
          rail.panel
            .classList
            .contains(
              'is-active'
            )
        );

      }


      /*
       * MOBILE:
       * all panels are interactive.
       *
       * DESKTOP:
       * only active tab panel is interactive.
       */
      syncLayout() {

        if (
          this.mobile.matches
        ) {

          this.stopAutoplay();


          this.panels.forEach(
            (panel) => {

              panel.inert =
                false;


              panel.removeAttribute(
                'aria-hidden'
              );


              this.initializePanel(
                panel
              );

            }
          );


          this.rails.forEach(
            (rail) => {

              if (
                !rail.image
              ) {

                rail.points =
                  [0];


                rail.index =
                  0;


                if (
                  rail.controls
                ) {

                  rail.controls.hidden =
                    true;

                }


              } else if (
                this.railIsVisible(
                  rail
                )
              ) {

                this.measure(
                  rail
                );

              }

            }
          );


        } else {


          this.panels.forEach(
            (
              panel,
              index
            ) => {

              const active =
                index ===
                this.activeIndex;


              panel.classList.toggle(
                'is-active',
                active
              );


              panel.inert =
                !active;


              if (active) {

                panel.removeAttribute(
                  'aria-hidden'
                );

              } else {

                panel.setAttribute(
                  'aria-hidden',
                  'true'
                );

              }

            }
          );


          const activePanel =
            this.panels[
              this.activeIndex
            ];


          if (activePanel) {

            this.initializePanel(
              activePanel
            );


            this.rails.forEach(
              (rail) => {

                if (
                  rail.panel ===
                    activePanel &&
                  this.railIsVisible(
                    rail
                  )
                ) {

                  this.measure(
                    rail
                  );

                }

              }
            );

          }


          this.scheduleAutoplay();

        }

      }


      /*
       * SWITCH DESKTOP TAB
       */
      activate(
        index,
        animate = true
      ) {

        if (
          !this.tabs[index] ||
          !this.panels[index]
        ) {
          return;
        }


        const oldPanel =
          this.panels[
            this.activeIndex
          ];


        const moveFocus =
          oldPanel?.contains(
            document.activeElement
          );


        this.rails.forEach(
          (rail) => {

            if (
              rail.panel ===
                oldPanel
            ) {

              rail.request++;

            }

          }
        );


        this.tabs.forEach(
          (
            tab,
            position
          ) => {

            const active =
              position === index;


            tab.setAttribute(
              'aria-selected',
              String(active)
            );


            tab.tabIndex =
              active
                ? 0
                : -1;

          }
        );


        this.activeIndex =
          index;


        const panel =
          this.panels[index];


        if (
          !this.mobile.matches
        ) {

          this.panels.forEach(
            (
              item,
              position
            ) => {

              const active =
                position ===
                index;


              item.classList.toggle(
                'is-active',
                active
              );


              item.inert =
                !active;


              if (active) {

                item.removeAttribute(
                  'aria-hidden'
                );

              } else {

                item.setAttribute(
                  'aria-hidden',
                  'true'
                );

              }

            }
          );

        }


        this.initializePanel(
          panel
        );


        if (
          panel.mainRail &&
          !this.mobile.matches
        ) {

          panel.mainRail.index =
            0;


          panel.mainRail.track.scrollTo({

            left: 0,

            behavior:
              'auto'

          });

        }


        this.rails.forEach(
          (rail) => {

            if (
              rail.panel ===
                panel &&
              this.railIsVisible(
                rail
              )
            ) {

              this.measure(
                rail
              );

            }

          }
        );


        const url =
          panel.dataset.viewAll;


        if (
          this.footer &&
          this.viewAll
        ) {

          this.footer.hidden =
            !url ||
            !this.viewAll
              .textContent
              .trim();


          if (url) {

            this.viewAll
              .setAttribute(
                'href',
                url
              );

          } else {

            this.viewAll
              .removeAttribute(
                'href'
              );

          }

        }


        panel.classList.remove(
          'lftc-enter'
        );


        if (
          animate &&
          this.dataset.animate ===
            'true' &&
          !this.motion.matches &&
          !this.mobile.matches
        ) {

          panel
            .getBoundingClientRect();


          panel.classList.add(
            'lftc-enter'
          );

        }


        if (
          moveFocus &&
          !this.mobile.matches
        ) {

          this.tabs[index]
            .focus({

              preventScroll:
                true

            });

        }


        this.restartAutoplay();

      }


      /*
       * INITIALISE PRODUCTS INSIDE PANEL
       */
      initializePanel(
        panel
      ) {

        if (
          !panel ||
          panel.initialized
        ) {
          return;
        }


        panel.initialized =
          true;


        const mainTrack =
          panel.querySelector(
            '[data-main-track]'
          );


        if (
          !mainTrack
        ) {
          return;
        }


        panel.mainRail =
          this.createRail({

            panel,

            track:
              mainTrack,

            items:
              [
                ...mainTrack.querySelectorAll(
                  '[data-card]'
                )
              ],

            previous:
              panel.querySelector(
                '[data-main-step="-1"]'
              ),

            next:
              panel.querySelector(
                '[data-main-step="1"]'
              ),

            controls:
              panel.querySelector(
                '[data-main-controls]'
              ),

            image:
              false

          });


        panel
          .querySelectorAll(
            '[data-gallery]'
          )
          .forEach(
            (gallery) => {

              const rail =
                this.createRail({

                  panel,

                  track:
                    gallery.querySelector(
                      '[data-image-track]'
                    ),

                  items:
                    [
                      ...gallery.querySelectorAll(
                        '[data-image-frame]'
                      )
                    ],

                  previous:
                    gallery.querySelector(
                      '[data-image-step="-1"]'
                    ),

                  next:
                    gallery.querySelector(
                      '[data-image-step="1"]'
                    ),

                  dots:
                    [
                      ...gallery.querySelectorAll(
                        '[data-image-dot]'
                      )
                    ],

                  image:
                    true,

                  name:
                    gallery.dataset.name

                });


              gallery.railState =
                rail;


              /*
               * Load first image for every
               * category when initialised.
               */
              this.hydrate(
                rail.items[0],
                false
              );


              gallery
                .querySelectorAll(
                  '[data-image-step], [data-image-dots]'
                )
                .forEach(
                  (control) => {

                    control.hidden =
                      false;

                  }
                );


              this.listen(
                gallery,
                'pointerenter',
                (event) => {

                  if (
                    event.pointerType ===
                      'mouse'
                  ) {

                    this.prime(
                      rail
                    );

                  }

                }
              );

            }
          );

      }


      createRail(
        options
      ) {

        const rail = {

          ...options,

          index:
            0,

          points:
            [0],

          request:
            0,

          used:
            false

        };


        this.rails.add(
          rail
        );


        this.listen(
          rail.track,
          'scroll',
          () => {

            if (
              rail.frame
            ) {
              return;
            }


            rail.frame =
              requestAnimationFrame(
                () => {

                  rail.frame =
                    null;


                  this.updateRail(
                    rail
                  );


                  if (
                    rail.image &&
                    rail.used
                  ) {

                    this.prime(
                      rail
                    );

                  }

                }
              );

          },
          {
            passive: true
          }
        );


        if (
          this.railIsVisible(
            rail
          )
        ) {

          this.measure(
            rail
          );

        }


        return rail;

      }


      measure(
        rail
      ) {

        if (
          !rail ||
          !rail.track ||
          !rail.track.clientWidth ||
          !rail.items.length
        ) {
          return;
        }


        /*
         * Mobile main product rails
         * are grids, not carousels.
         */
        if (
          !rail.image &&
          this.mobile.matches
        ) {

          rail.points =
            [0];


          rail.index =
            0;


          if (
            rail.controls
          ) {

            rail.controls.hidden =
              true;

          }


          return;

        }


        if (
          !this.railIsVisible(
            rail
          )
        ) {
          return;
        }


        rail.rtl =
          getComputedStyle(
            rail.track
          ).direction ===
          'rtl';


        const maximum =
          Math.max(

            0,

            rail.track.scrollWidth -
              rail.track.clientWidth

          );


        const first =
          rail.items[0]
            .getBoundingClientRect();


        const points =
          [];


        rail.items.forEach(
          (item) => {

            const rect =
              item
                .getBoundingClientRect();


            const distance =
              rail.rtl

                ? first.right -
                  rect.right

                : rect.left -
                  first.left;


            const point =
              Math.max(

                0,

                Math.min(
                  distance,
                  maximum
                )

              );


            if (
              !points.length ||
              Math.abs(
                point -
                points.at(-1)
              ) > 2
            ) {

              points.push(
                point
              );

            }

          }
        );


        rail.points =
          points.length
            ? points
            : [0];


        rail.index =
          Math.min(
            rail.index,
            rail.points.length - 1
          );


        rail.track.scrollTo({

          left:
            rail.points[
              rail.index
            ] *
            (
              rail.rtl
                ? -1
                : 1
            ),

          behavior:
            'auto'

        });


        if (
          rail.controls
        ) {

          rail.controls.hidden =
            maximum < 3;

        }


        this.updateRail(
          rail
        );

      }


      updateRail(
        rail
      ) {

        if (
          !rail?.track ||
          !rail.points?.length
        ) {
          return;
        }


        const position =
          Math.abs(
            rail.track.scrollLeft
          );


        rail.index =
          rail.points.reduce(
            (
              closest,
              point,
              index
            ) => {

              return (
                Math.abs(
                  point -
                  position
                ) <
                Math.abs(
                  rail.points[
                    closest
                  ] -
                  position
                )
              )

                ? index
                : closest;

            },
            0
          );


        if (
          rail.previous
        ) {

          rail.previous.disabled =
            rail.index === 0;

        }


        if (
          rail.next
        ) {

          rail.next.disabled =
            rail.index ===
            rail.points.length - 1;

        }


        if (
          rail.image
        ) {

          rail.items.forEach(
            (
              frame,
              index
            ) => {

              const active =
                index ===
                rail.index;


              frame.inert =
                !active;


              frame.setAttribute(
                'aria-hidden',
                String(!active)
              );

            }
          );


          rail.dots?.forEach(
            (
              dot,
              index
            ) => {

              if (
                index ===
                rail.index
              ) {

                dot.setAttribute(
                  'aria-current',
                  'true'
                );

              } else {

                dot.removeAttribute(
                  'aria-current'
                );

              }

            }
          );

        }

      }


      hydrate(
        frame,
        urgent = true
      ) {

        if (
          !frame
        ) {
          return null;
        }


        const template =
          frame.querySelector(
            '[data-image-template]'
          );


        if (template) {

          const fragment =
            template.content
              .cloneNode(
                true
              );


          const image =
            fragment.querySelector(
              'img'
            );


          if (image) {

            image.loading =
              urgent
                ? 'eager'
                : 'lazy';

          }


          template.replaceWith(
            fragment
          );

        }


        const image =
          frame.querySelector(
            'img'
          );


        if (
          image &&
          urgent
        ) {

          image.loading =
            'eager';

        }


        return image;

      }


      prime(
        rail
      ) {

        this.hydrate(
          rail.items[
            rail.index
          ]
        );


        this.hydrate(
          rail.items[
            rail.index + 1
          ]
        );


        this.hydrate(
          rail.items[
            rail.index - 1
          ]
        );

      }


      async go(
        rail,
        destination
      ) {

        if (
          !rail ||
          (
            !rail.image &&
            this.mobile.matches
          )
        ) {
          return;
        }


        const target =
          Math.max(

            0,

            Math.min(

              destination,

              rail.points.length -
                1

            )

          );


        const request =
          ++rail.request;


        if (
          rail.image
        ) {

          rail.used =
            true;


          const image =
            this.hydrate(
              rail.items[target]
            );


          if (image) {

            try {

              await image.decode();

            } catch {

              if (
                !image.naturalWidth
              ) {

                if (
                  this.isConnected &&
                  request ===
                    rail.request
                ) {

                  this.status.textContent =
                    'This product image could not load.';

                }


                return;

              }

            }

          }

        }


        if (
          !this.isConnected ||
          request !==
            rail.request ||
          !this.railIsVisible(
            rail
          )
        ) {
          return;
        }


        rail.track.scrollTo({

          left:
            rail.points[
              target
            ] *
            (
              rail.rtl
                ? -1
                : 1
            ),

          behavior:
            this.motion.matches
              ? 'auto'
              : 'smooth'

        });


        if (
          rail.image
        ) {

          this.status.textContent =
            `Image ${
              target + 1
            } of ${
              rail.items.length
            } for ${
              rail.name
            }.`;

        }

      }


      /* =====================================
         DESKTOP AUTOPLAY
      ====================================== */

      stopAutoplay() {

        if (
          this.autoplayTimer
        ) {

          clearTimeout(
            this.autoplayTimer
          );


          this.autoplayTimer =
            null;

        }

      }


      restartAutoplay() {

        this.stopAutoplay();


        window.setTimeout(
          () => {

            if (
              this.isConnected
            ) {

              this.scheduleAutoplay();

            }

          },
          0
        );

      }


      scheduleAutoplay() {

        this.stopAutoplay();


        if (
          !this.controller ||
          !this.isConnected ||
          this.mobile.matches ||
          this.dataset.autoplay !==
            'true' ||
          this.motion.matches ||
          document.hidden ||
          this.pointer ||
          this.contains(
            document.activeElement
          )
        ) {

          return;

        }


        const panel =
          this.panels[
            this.activeIndex
          ];


        const rail =
          panel?.mainRail;


        if (
          !rail ||
          !this.railIsVisible(
            rail
          ) ||
          rail.points.length < 2
        ) {

          return;

        }


        this.autoplayTimer =
          window.setTimeout(

            async () => {

              this.autoplayTimer =
                null;


              if (
                !this.isConnected ||
                this.mobile.matches ||
                panel !==
                  this.panels[
                    this.activeIndex
                  ]
              ) {

                return;

              }


              this.updateRail(
                rail
              );


              const nextIndex =
                rail.index >=
                rail.points.length -
                  1

                  ? 0

                  : rail.index +
                    1;


              await this.go(
                rail,
                nextIndex
              );


              this.scheduleAutoplay();

            },

            this.autoplayDelay

          );

      }


      /* =====================================
         WISHLIST
      ====================================== */

      readWishlist() {

        try {

          const value =
            JSON.parse(

              localStorage.getItem(
                this.wishlistKey
              ) ||
              '[]'

            );


          return new Set(

            Array.isArray(
              value
            )

              ? value.filter(
                  (id) =>
                    typeof id ===
                    'string'
                )

              : []

          );


        } catch {

          return new Set();

        }

      }


      syncWishlist() {

        const saved =
          this.readWishlist();


        this
          .querySelectorAll(
            '[data-wishlist]'
          )
          .forEach(
            (button) => {

              const active =
                saved.has(
                  button.dataset
                    .productId
                );


              button.setAttribute(
                'aria-pressed',
                String(active)
              );


              button.setAttribute(

                'aria-label',

                `${
                  active
                    ? 'Remove'
                    : 'Save'
                } ${
                  button.dataset
                    .productTitle
                } ${
                  active
                    ? 'from'
                    : 'to'
                } wishlist`

              );

            }
          );

      }


      toggleWishlist(
        button
      ) {

        const saved =
          this.readWishlist();


        const id =
          button.dataset
            .productId;


        const removing =
          saved.has(id);


        if (removing) {

          saved.delete(id);

        } else {

          saved.add(id);

        }


        try {

          localStorage.setItem(

            this.wishlistKey,

            JSON.stringify(
              [...saved]
            )

          );


          window.dispatchEvent(

            new CustomEvent(
              'littlefits:wishlistchange'
            )

          );


          this.status.textContent =
            `${
              button.dataset
                .productTitle
            } ${
              removing
                ? 'removed from'
                : 'saved to'
            } your wishlist on this browser.`;


        } catch {

          this.status.textContent =
            'Your browser could not save this wishlist selection.';

        }

      }


      /* =====================================
         REVEAL
      ====================================== */

      setupReveal() {

        if (
          this.dataset.animate !==
            'true' ||
          this.motion.matches ||
          !this.mobile.matches ||
          window.Shopify
            ?.designMode ||
          !(
            'IntersectionObserver'
            in window
          )
        ) {

          return;

        }


        this.classList.add(
          'lftc-reveal-pending'
        );


        this.getBoundingClientRect();


        this.classList.add(
          'lftc-reveal-ready'
        );


        this.revealObserver =
          new IntersectionObserver(

            (entries) => {

              if (
                entries.some(
                  (entry) =>
                    entry.isIntersecting
                )
              ) {

                this.reveal();

              }

            },

            {
              threshold: .08
            }

          );


        this.revealObserver
          .observe(
            this
          );

      }


      reveal() {

        this.classList.remove(
          'lftc-reveal-pending'
        );


        this.revealObserver
          ?.disconnect();

      }


      disconnectedCallback() {

        this.stopAutoplay();


        this.controller
          ?.abort();


        this.resizeObserver
          ?.disconnect();


        this.revealObserver
          ?.disconnect();


        this.rails
          ?.forEach(
            (rail) => {

              rail.request++;

              cancelAnimationFrame(
                rail.frame
              );

            }
          );


        this.panels
          ?.forEach(
            (panel) => {

              panel.initialized =
                false;


              panel.mainRail =
                null;

            }
          );


        this.classList.remove(
          'is-ready',
          'lftc-reveal-pending'
        );


        this.controller =
          null;

      }

    }


    customElements.define(
      'littlefits-product-tabs',
      LittlefitsProductTabs
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["littlefits-triple-video-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'littlefits-triple-video-v2';

    if (customElements.get(elementName)) return;

    function loadYouTubeAPI() {
      if (window.YT?.Player) {
        return Promise.resolve(window.YT);
      }

      if (window.littlefitsYouTubeAPI) {
        return window.littlefitsYouTubeAPI;
      }

      window.littlefitsYouTubeAPI = new Promise((resolve, reject) => {
        const previous = window.onYouTubeIframeAPIReady;

        const timeout = setTimeout(() => {
          reject(new Error('YouTube API timed out'));
        }, 15000);

        window.onYouTubeIframeAPIReady = () => {
          clearTimeout(timeout);

          try {
            if (typeof previous === 'function') previous();
          } finally {
            resolve(window.YT);
          }
        };

        const existingScript = document.querySelector(
          'script[src="https://www.youtube.com/iframe_api"]'
        );

        if (!existingScript) {
          const script = document.createElement('script');
          script.src = 'https://www.youtube.com/iframe_api';
          script.async = true;

          script.onerror = () => {
            clearTimeout(timeout);
            script.remove();
            reject(new Error('YouTube API failed'));
          };

          document.head.append(script);
        }
      }).catch((error) => {
        window.littlefitsYouTubeAPI = null;
        throw error;
      });

      return window.littlefitsYouTubeAPI;
    }

    class LittlefitsTripleVideoV2 extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();
        this.session = (this.session || 0) + 1;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.autoplay = this.dataset.autoplay === 'true';
        this.loop = this.dataset.loop === 'true';

        this.states = [...this.querySelectorAll('[data-video-card]')]
          .filter((card) => card.dataset.valid === 'true')
          .map((card) => ({
            card,
            frame: card.querySelector('[data-frame]'),
            media: card.querySelector('[data-media]'),
            source: card.dataset.source,
            youtubeId: card.dataset.youtubeId,
            ratio: Number(card.dataset.youtubeRatio) || 16 / 9,

            position: this.readPosition(card.dataset.position),

            verticalPosition: this.readPosition(
              card.dataset.verticalPosition
            ),

            zoomDesktop: Math.max(
              1,
              (Number(card.dataset.zoomDesktop) || 100) / 100
            ),

            zoomMobile: Math.max(
              1,
              (Number(card.dataset.zoomMobile) || 100) / 100
            ),

            near: false,
            ready: false,
            initializing: false,
            failed: false,
            blocked: false,
            ended: false
          }));

        const stateByCard = new Map(
          this.states.map((state) => [state.card, state])
        );

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const state = stateByCard.get(entry.target);
                if (!state) return;

                state.near = entry.isIntersecting;
                this.sync(state);
              });
            },
            {
              rootMargin: '160px 0px',
              threshold: 0
            }
          );

          this.states.forEach((state) => {
            this.visibilityObserver.observe(state.card);
          });
        } else {
          this.states.forEach((state) => {
            state.near = true;
            this.sync(state);
          });
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            this.updateLayout();
          });

          this.states.forEach((state) => {
            this.resizeObserver.observe(state.frame);
          });
        }

        this.listen(window, 'resize', () => this.updateLayout(), {
          passive: true
        });

        this.listen(this.mobile, 'change', () => this.updateLayout());

        this.listen(document, 'visibilitychange', () => {
          this.states.forEach((state) => this.sync(state));
        });

        this.listen(this.motion, 'change', () => {
          this.states.forEach((state) => {
            if (this.motion.matches) {
              state.card.classList.remove('has-frame');
            }

            this.sync(state);
          });
        });

        this.updateLayout();
      }

      readPosition(value) {
        const number = Number(value ?? 50);

        return Number.isFinite(number)
          ? Math.max(0, Math.min(1, number / 100))
          : 0.5;
      }

      listen(target, event, callback, options = {}) {
        target.addEventListener(event, callback, {
          ...options,
          signal: this.controller.signal
        });
      }

      shouldPlay(state) {
        return (
          this.isConnected &&
          this.autoplay &&
          !this.motion.matches &&
          !document.hidden &&
          state.near &&
          !state.failed &&
          !state.blocked &&
          (!state.ended || this.loop)
        );
      }

      sync(state) {
        if (!this.shouldPlay(state)) {
          this.pause(state);
          return;
        }

        if (state.source === 'shopify') {
          if (!state.video) this.createNative(state);
          this.playNative(state);
          return;
        }

        if (!state.player && !state.initializing) {
          this.createYouTube(state);
        }

        if (state.ready) {
          try {
            this.resizeYouTube(state);
            state.player.mute();

            const status = state.player.getPlayerState();

            if (status !== 1 && status !== 3) {
              state.player.playVideo();
            }
          } catch {
            this.fail(state);
          }
        }
      }

      createNative(state) {
        const template = state.card.querySelector('[data-native-video]');
        if (!template) return;

        const fragment = template.content.cloneNode(true);
        const video = fragment.querySelector('video');
        if (!video) return;

        state.video = video;

        video.autoplay = false;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = this.loop;
        video.playsInline = true;
        video.controls = false;
        video.preload = 'metadata';
        video.disablePictureInPicture = true;
        video.disableRemotePlayback = true;
        video.tabIndex = -1;

        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('aria-hidden', 'true');
        video.removeAttribute('controls');

        video.querySelectorAll('track').forEach((track) => {
          track.remove();
        });

        const disableTracks = () => {
          for (const track of video.textTracks) {
            track.mode = 'disabled';
          }
        };

        this.listen(video, 'loadedmetadata', disableTracks);
        this.listen(video.textTracks, 'addtrack', disableTracks);

        this.listen(video, 'volumechange', () => {
          if (!video.muted) video.muted = true;
        });

        this.listen(video, 'playing', () => {
          if (!this.shouldPlay(state)) {
            this.pause(state);
            return;
          }

          state.card.classList.add('has-frame');
        });

        this.listen(video, 'ended', () => {
          if (!this.loop) {
            state.ended = true;
          } else if (this.shouldPlay(state)) {
            this.playNative(state);
          }
        });

        this.listen(video, 'error', () => this.fail(state));

        state.media.append(fragment);
      }

      playNative(state) {
        const video = state.video;

        if (
          !video ||
          state.playPending ||
          !video.paused ||
          !this.shouldPlay(state)
        ) return;

        const session = this.session;

        state.playPending = true;
        video.muted = true;
        video.autoplay = true;

        video.play()
          .catch((error) => {
            if (error.name === 'AbortError') return;

            if (
              session !== this.session ||
              !this.isConnected ||
              !this.shouldPlay(state)
            ) return;

            state.blocked = true;
            state.card.classList.remove('has-frame');
          })
          .finally(() => {
            state.playPending = false;
          });
      }

      createYouTube(state) {
        state.initializing = true;

        const session = this.session;
        const alive = () => (
          this.isConnected && session === this.session
        );

        loadYouTubeAPI()
          .then((YT) => {
            if (!alive()) return;

            if (!this.shouldPlay(state)) {
              state.initializing = false;
              return;
            }

            const mount = document.createElement('div');
            state.media.append(mount);

            const parameters = {
              autoplay: 1,
              mute: 1,
              controls: 0,
              loop: this.loop ? 1 : 0,
              playsinline: 1,
              enablejsapi: 1,
              disablekb: 1,
              fs: 0,
              rel: 0,
              iv_load_policy: 3,
              cc_load_policy: 0,
              origin: window.location.origin
            };

            if (this.loop) {
              parameters.playlist = state.youtubeId;
            }

            state.timeout = setTimeout(() => {
              if (alive()) this.fail(state);
            }, 15000);

            state.player = new YT.Player(mount, {
              videoId: state.youtubeId,
              playerVars: parameters,

              events: {
                onReady: (event) => {
                  if (!alive()) return;

                  clearTimeout(state.timeout);
                  state.initializing = false;
                  state.ready = true;

                  event.target.mute();
                  event.target.setVolume(0);

                  const iframe = event.target.getIframe();

                  iframe.title = 'Littlefits campaign video';
                  iframe.tabIndex = -1;
                  iframe.setAttribute('aria-hidden', 'true');
                  iframe.setAttribute(
                    'allow',
                    'autoplay; encrypted-media'
                  );

                  this.resizeYouTube(state);
                  this.sync(state);
                },

                onStateChange: (event) => {
                  if (!alive()) return;

                  if (event.data === 1) {
                    event.target.mute();
                    this.resizeYouTube(state);

                    if (this.shouldPlay(state)) {
                      state.card.classList.add('has-frame');
                    } else {
                      this.pause(state);
                    }
                  }

                  if (event.data === 0 && !this.loop) {
                    state.ended = true;
                  }
                },

                onAutoplayBlocked: () => {
                  if (!alive()) return;

                  state.blocked = true;
                  state.card.classList.remove('has-frame');
                  this.pause(state);
                },

                onError: () => {
                  if (!alive()) return;

                  clearTimeout(state.timeout);
                  this.fail(state);
                }
              }
            });
          })
          .catch(() => {
            if (alive()) this.fail(state);
          });
      }

      pause(state) {
        if (state.video) {
          state.video.autoplay = false;

          if (!state.video.paused) {
            state.video.pause();
          }
        }

        if (state.ready) {
          try {
            const status = state.player.getPlayerState();

            if (status === 1 || status === 3) {
              state.player.pauseVideo();
            }
          } catch {
            // The player may be unloading in the theme editor.
          }
        }
      }

      fail(state) {
        state.failed = true;
        state.card.classList.remove('has-frame');
        this.pause(state);
      }

      resizeYouTube(state) {
        if (!state.ready || !state.player) return;

        const iframe = state.player.getIframe();
        if (!iframe) return;

        const frame = state.frame.getBoundingClientRect();
        const width = frame.width;
        const height = frame.height;

        if (!width || !height) return;

        const ratio = state.ratio > 0 ? state.ratio : 16 / 9;

        const zoom = this.mobile.matches
          ? state.zoomMobile
          : state.zoomDesktop;

        const iframeWidth = Math.max(width, height * ratio) * zoom;
        const iframeHeight = iframeWidth / ratio;

        const left = (width - iframeWidth) * state.position;
        const top = (height - iframeHeight) * state.verticalPosition;

        iframe.style.setProperty(
          'width',
          `${iframeWidth}px`,
          'important'
        );

        iframe.style.setProperty(
          'height',
          `${iframeHeight}px`,
          'important'
        );

        iframe.style.setProperty('inset', 'auto', 'important');
        iframe.style.setProperty('left', `${left}px`, 'important');
        iframe.style.setProperty('top', `${top}px`, 'important');
        iframe.style.setProperty('right', 'auto', 'important');
        iframe.style.setProperty('bottom', 'auto', 'important');
        iframe.style.setProperty('transform', 'none', 'important');
      }

      updateLayout() {
        this.states.forEach((state) => {
          this.resizeYouTube(state);
        });
      }

      disconnectedCallback() {
        this.session++;
        this.controller?.abort();
        this.visibilityObserver?.disconnect();
        this.resizeObserver?.disconnect();

        this.states?.forEach((state) => {
          clearTimeout(state.timeout);

          if (state.video) {
            state.video.autoplay = false;
            state.video.pause();

            state.video.querySelectorAll('source').forEach((source) => {
              source.removeAttribute('src');
            });

            state.video.removeAttribute('src');
            state.video.load();
          }

          try {
            state.player?.destroy();
          } catch {
            // The iframe may already have been removed.
          }

          state.media.replaceChildren();
          state.card.classList.remove('has-frame');
        });

        this.controller = null;
      }
    }

    customElements.define(elementName, LittlefitsTripleVideoV2);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["littlefits-video-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('littlefits-video-banner')) return;

    function loadYouTubeAPI() {
      if (window.YT?.Player) return Promise.resolve(window.YT);
      if (window.littlefitsYouTubeAPI) return window.littlefitsYouTubeAPI;

      window.littlefitsYouTubeAPI = new Promise((resolve, reject) => {
        const previous = window.onYouTubeIframeAPIReady;

        const timeout = setTimeout(() => {
          reject(new Error('YouTube API timed out'));
        }, 15000);

        window.onYouTubeIframeAPIReady = () => {
          clearTimeout(timeout);

          try {
            if (typeof previous === 'function') previous();
          } finally {
            resolve(window.YT);
          }
        };

        if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
          const script = document.createElement('script');
          script.src = 'https://www.youtube.com/iframe_api';
          script.async = true;

          script.onerror = () => {
            clearTimeout(timeout);
            script.remove();
            reject(new Error('YouTube API could not load'));
          };

          document.head.append(script);
        }
      }).catch((error) => {
        window.littlefitsYouTubeAPI = null;
        throw error;
      });

      return window.littlefitsYouTubeAPI;
    }

    class LittlefitsVideoBanner extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.cfg = JSON.parse(
          this.querySelector('[data-video-config]').textContent
        );
        if (!this.cfg.hasVideo) return;

        this.controller = new AbortController();
        this.stage = this.querySelector('[data-stage]');
        this.media = this.querySelector('[data-media]');
        this.button = this.querySelector('[data-playback]');
        this.status = this.querySelector('[data-status]');

        this.mobile = matchMedia('(max-width: 749px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.savedTimes = new Map();
        this.generation = 0;
        this.active = false;
        this.hasFrame = false;
        this.failed = false;
        this.wantsPlay =
          this.cfg.autoplay &&
          !this.motion.matches &&
          !window.Shopify?.designMode;

        this.listen(this.button, 'click', () => {
          if (this.wantsPlay) {
            this.wantsPlay = false;
          } else {
            if (this.failed) {
              this.disposeMedia();
              this.failed = false;
            }

            this.status.textContent = '';
            this.active = true;
            this.wantsPlay = true;
          }

          this.sync();
        });

        this.listen(document, 'visibilitychange', () => this.sync());

        this.listen(this.motion, 'change', () => {
          if (this.motion.matches) {
            this.wantsPlay = false;
            this.hasFrame = false;
            this.classList.remove('has-frame');
            this.sync();
          }
        });

        this.listen(this.mobile, 'change', () => {
          if (this.cfg.source === 'shopify') {
            const template = this.selectedTemplate();

            if (
              this.currentKey &&
              template?.dataset.videoKey !== this.currentKey
            ) {
              this.disposeMedia();
              this.sync();
            }
          }

          this.resizeYouTube();
        });

        this.resizeObserver = new ResizeObserver(() => {
          this.resizeYouTube();
        });
        this.resizeObserver.observe(this.stage);

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver((entries) => {
            this.active = entries[0].isIntersecting;
            this.sync();
          }, { rootMargin: '150px 0px', threshold: 0 });

          this.visibilityObserver.observe(this.stage);
        } else {
          this.active = true;
          this.sync();
        }

        this.updateButton();
      }

      listen(target, event, callback, options = {}) {
        target.addEventListener(event, callback, {
          ...options,
          signal: this.controller.signal
        });
      }

      canPlay() {
        return (
          this.isConnected &&
          this.wantsPlay &&
          this.active &&
          !document.hidden &&
          !this.failed
        );
      }

      selectedTemplate() {
        return this.querySelector(
          `[data-video-template="${this.mobile.matches ? 'mobile' : 'desktop'}"]`
        );
      }

      sync() {
        if (!this.canPlay()) {
          this.pauseForSystem();
          this.updateButton();
          return;
        }

        if (this.cfg.source === 'shopify') {
          if (!this.video) this.createNativeVideo();
          this.playNativeVideo();
        } else {
          if (!this.player && !this.initializing) this.createYouTube();

          if (this.playerReady) {
            this.player.playVideo();
          }
        }

        this.updateButton();
      }

      createNativeVideo() {
        const template = this.selectedTemplate();
        if (!template) return;

        this.currentKey = template.dataset.videoKey;
        this.mediaController = new AbortController();

        const fragment = template.content.cloneNode(true);
        this.video = fragment.querySelector('video');
        if (!this.video) return;

        const video = this.video;
        const listen = (name, callback) => {
          video.addEventListener(name, callback, {
            signal: this.mediaController.signal
          });
        };

        // Decide playback before attaching the video to the live DOM.
        video.autoplay = false;
        video.muted = this.cfg.muted;
        video.defaultMuted = this.cfg.muted;
        video.loop = this.cfg.loop;
        video.playsInline = true;
        video.controls = this.cfg.nativeControls;
        video.preload = 'metadata';
        video.setAttribute('playsinline', '');
        video.setAttribute('aria-label', 'Littlefits campaign video');

        if (!this.cfg.nativeControls) {
          video.setAttribute('aria-hidden', 'true');
          video.tabIndex = -1;
        }

        listen('loadedmetadata', () => {
          const saved = this.savedTimes.get(this.currentKey);

          if (saved && Number.isFinite(video.duration)) {
            video.currentTime = Math.min(
              saved,
              Math.max(0, video.duration - 0.1)
            );
          }
        });

        listen('play', () => {
          // Native-control playback is also an explicit user action.
          if (this.cfg.nativeControls && !this.playPending) {
            this.wantsPlay = true;
          }
        });

        listen('playing', () => {
          if (!this.canPlay()) {
            this.pauseForSystem();
            return;
          }

          this.hasFrame = true;
          this.classList.add('has-frame');
          this.updateButton();
        });

        listen('pause', () => {
          if (this.ignoreNativePause > 0) {
            this.ignoreNativePause--;
          } else if (!video.ended) {
            this.wantsPlay = false;
          }

          this.updateButton();
        });

        listen('ended', () => {
          if (this.cfg.loop && this.wantsPlay) {
            this.sync();
          } else {
            this.wantsPlay = false;
            this.updateButton();
          }
        });

        listen('error', () => this.fail(
          'The video could not load. The poster remains visible.'
        ));

        this.ignoreNativePause = 0;
        this.media.append(fragment);
      }

      playNativeVideo() {
        if (!this.video || this.playPending || !this.canPlay()) return;
        if (!this.video.paused) return;

        const video = this.video;
        this.playPending = true;

        video.autoplay =
          this.cfg.autoplay && !this.motion.matches && this.wantsPlay;

        video.play()
          .catch((error) => {
            if (
              error.name !== 'AbortError' &&
              this.video === video &&
              this.canPlay()
            ) {
              this.wantsPlay = false;
              this.status.textContent =
                'Automatic playback was blocked. Press Play to start the video.';
              this.updateButton();
            }
          })
          .finally(() => {
            if (this.video === video) this.playPending = false;
          });
      }

      createYouTube() {
        this.initializing = true;
        const generation = this.generation;

        loadYouTubeAPI()
          .then((YT) => {
            if (!this.isConnected || generation !== this.generation) return;

            const mount = document.createElement('div');
            this.media.append(mount);

            const variables = {
              autoplay: 0,
              controls: this.cfg.nativeControls ? 1 : 0,
              playsinline: 1,
              loop: this.cfg.loop ? 1 : 0,
              rel: 0,
              fs: this.cfg.nativeControls ? 1 : 0,
              disablekb: this.cfg.nativeControls ? 0 : 1,
              origin: window.location.origin
            };

            if (this.cfg.loop) {
              variables.playlist = this.cfg.youtubeId;
            }

            this.playerTimeout = setTimeout(() => {
              if (generation === this.generation) {
                this.fail('The YouTube player could not load.');
              }
            }, 15000);

            this.player = new YT.Player(mount, {
              videoId: this.cfg.youtubeId,
              playerVars: variables,
              events: {
                onReady: (event) => {
                  if (generation !== this.generation || !this.isConnected) return;

                  clearTimeout(this.playerTimeout);
                  this.initializing = false;
                  this.playerReady = true;

                  const iframe = event.target.getIframe();
                  iframe.title = 'Littlefits campaign video';
                  iframe.setAttribute(
                    'allow',
                    'autoplay; encrypted-media; picture-in-picture; fullscreen'
                  );

                  if (!this.cfg.nativeControls) {
                    iframe.setAttribute('aria-hidden', 'true');
                    iframe.tabIndex = -1;
                    iframe.style.pointerEvents = 'none';
                  }

                  if (this.cfg.muted) event.target.mute();
                  else event.target.unMute();

                  this.resizeYouTube();
                  this.sync();
                },

                onStateChange: (event) => {
                  if (generation !== this.generation || !this.isConnected) return;
                  this.handleYouTubeState(event.data);
                },

                onError: () => {
                  if (generation !== this.generation) return;
                  clearTimeout(this.playerTimeout);
                  this.fail(
                    'This YouTube video could not play. Check its sharing and embedding settings.'
                  );
                },

                onAutoplayBlocked: () => {
                  if (generation !== this.generation) return;
                  this.wantsPlay = false;
                  this.status.textContent =
                    'Playback was blocked. Press Play to try again.';
                  this.updateButton();
                }
              }
            });
          })
          .catch(() => {
            if (this.isConnected && generation === this.generation) {
              this.fail('The YouTube player could not load.');
            }
          });
      }

      handleYouTubeState(state) {
        if (state === 1) {
          if (
            !this.wantsPlay &&
            this.cfg.nativeControls &&
            !this.ignoreYouTubePause
          ) {
            this.wantsPlay = true;
          }

          if (!this.canPlay()) {
            this.pauseForSystem();
            return;
          }

          this.ignoreYouTubePause = false;
          this.hasFrame = true;
          this.classList.add('has-frame');
        }

        if (state === 2) {
          if (this.ignoreYouTubePause) {
            this.ignoreYouTubePause = false;
          } else {
            this.wantsPlay = false;
          }
        }

        if (state === 0 && !this.cfg.loop) {
          this.wantsPlay = false;
        }

        // Do not reinsert the iframe or reveal the poster during a loop.
        this.updateButton();
      }

      pauseForSystem() {
        if (this.video) {
          this.video.autoplay = false;

          if (!this.video.paused) {
            this.ignoreNativePause++;
            this.video.pause();
          }
        }

        if (this.playerReady) {
          const state = this.player.getPlayerState();

          if (state === 1 || state === 3) {
            this.ignoreYouTubePause = true;
            this.player.pauseVideo();
          }
        }
      }

      resizeYouTube() {
        if (!this.playerReady) return;

        const iframe = this.player.getIframe();
        const width = this.stage.clientWidth;
        const height = this.stage.clientHeight;

        if (this.cfg.nativeControls) {
          // Keep native YouTube controls inside the visible player.
          iframe.style.width = `${width}px`;
          iframe.style.height = `${height}px`;
          iframe.style.left = '0px';
          iframe.style.top = '0px';
          return;
        }

        const ratio = 16 / 9;
        const frameWidth = Math.max(width, height * ratio);
        const frameHeight = frameWidth / ratio;
        const position = (
          this.mobile.matches
            ? this.cfg.mobilePosition
            : this.cfg.desktopPosition
        ) / 100;

        iframe.style.width = `${frameWidth}px`;
        iframe.style.height = `${frameHeight}px`;
        iframe.style.left = `${(width - frameWidth) * position}px`;
        iframe.style.top = `${(height - frameHeight) / 2}px`;
      }

      fail(message) {
        this.failed = true;
        this.wantsPlay = false;
        this.hasFrame = false;
        this.classList.remove('has-frame');
        this.pauseForSystem();
        this.status.textContent = message;
        this.updateButton();
      }

      updateButton() {
        if (!this.button) return;

        // Preserve a usable playback control when native controls are absent,
        // or when a poster is covering a player that has not started yet.
        const needsFallback = !this.cfg.nativeControls || !this.hasFrame;

        this.button.hidden =
          !this.cfg.customControls && !needsFallback;

        const label = this.wantsPlay
          ? 'Pause campaign video'
          : 'Play campaign video';

        this.button.setAttribute('aria-label', label);
        this.button.title = label;
        this.button.querySelector('[data-play-icon]').hidden = this.wantsPlay;
        this.button.querySelector('[data-pause-icon]').hidden = !this.wantsPlay;
      }

      disposeMedia() {
        this.generation++;

        if (this.video && this.currentKey) {
          this.savedTimes.set(this.currentKey, this.video.currentTime || 0);
        }

        this.mediaController?.abort();

        if (this.video) {
          this.video.autoplay = false;
          this.video.pause();
          this.video.querySelectorAll('source').forEach((source) => {
            source.removeAttribute('src');
          });
          this.video.removeAttribute('src');
          this.video.load();
        }

        clearTimeout(this.playerTimeout);

        try {
          this.player?.destroy();
        } catch {
          // The player may already have been removed by the theme editor.
        }

        this.media?.replaceChildren();
        this.video = null;
        this.player = null;
        this.playerReady = false;
        this.initializing = false;
        this.playPending = false;
        this.ignoreYouTubePause = false;
        this.ignoreNativePause = 0;
        this.currentKey = null;
        this.hasFrame = false;
        this.classList.remove('has-frame');
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller?.abort();

        if (this.media) this.disposeMedia();

        this.controller = null;
      }
    }

    customElements.define('littlefits-video-banner', LittlefitsVideoBanner);
  })();

  } catch(e) { console.error(e); }
})();
})();
